import React, { useEffect, useState, useRef } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'

import { useBaseContext } from 'context/base'
import TemplateAdmin from 'component/admin/TemplateAdmin'
import { Container, Header } from 'component/template'
import SubmitButton from 'component/button/Submit'
import InvalidText from 'component/invalid/text'
import { FormSwitch } from 'component/forms'
import { getMediaDuration } from 'util/global'
import {
  FormInputName,
  FormInputUrutan,
  FormSelectSection,
  FormSelectPrecontent,
  FormInputTanggal,
  FormActiveStatus,
  FormSelectFeedback,
  FormGroupKecil,
  FormInputDesc,
  FormActiveKey,
  FormInputEndedAt,
  FormVideoNav,
  PreviewVideoLink,
  InfoGdrive,
  FormTextArea,
  FormSetToBeScore,
  FormSelectStudent,
} from 'component/content-form'

export default function AddContentVideo() {
  /* ========================================== Helpers ========================================= */
  const history = useHistory()
  const location = useLocation()
  const params = useParams()

  /* ====================================== Consume Context ===================================== */
  const { getRequest, postRequest } = useBaseContext()

  /* ========================================= Constants ======================================== */
  const links = [
    { url: '/kelas', name: 'Sub Mata Pelajaran' },
    { url: `/kelas/${location.state.kelasId}`, name: 'Overview' },
  ]
  const sections = location.state.sectionList ? location.state.sectionList : []

  /* ======================================= Local States ======================================= */
  const [existingContents, setExistingContents]   = useState([])
  const [namaKonten, setNamaKonten]               = useState('')
  const [urutan, setUrutan]                       = useState('')
  const [sectionId, setSectionId]                 = useState('')
  const [preContentId, setPrecontentId]           = useState('')
  const [active, setActive]                       = useState(0)
  const [displayAt, setDisplayAt]                 = useState('')
  const [selectVideoSource, setSelectVideoSource] = useState({ link    : true, internal: false })
  const [feeds, setFeeds]                         = useState([])
  const [feedId, setFeedId]                       = useState(null)
  const [isFeedActive, setIsFeedActive]           = useState(0)
  const [enableGroup, setEnableGroup]             = useState(false)
  const [maxGroup, setMaxGroup]                   = useState('')
  const [descGroup, setDescGroup]                 = useState('')
  const [endedAt, setEndedAt]                     = useState('')
  const [description, setDescription]             = useState('')
  const [vidshowNav, setVidshowNav]               = useState(1)
  const [apresiasi, setApresiasi]                 = useState('')
  const [files, setFiles]                         = useState(null)
  const [rating, setRating]                       = useState(1)
  const [toBeScore, setToBeScore]   = useState({
    isScore: false,
    isKeterampilan: false,
    isPengetahuan: false,
    selectedTypeScore: '',
    isTypeScoreActive: true,
  })
  const [selectedStudents, setSelectedStudents] = useState([])

  const [enableGroupKey, setEnableGroupKey] = useState(false)
  const [prerequisite, setPrerequisite]     = useState('')

  // FORM FILE STATES
  const [contentsUrlLink, setContentsUrlLink]       = useState('')
  const [contentUrlInternal, setContentUrlInternal] = useState('')
  const [previewVideo, setPreviewVideo]             = useState('')
  const [linkContent, setLink]                      = useState('')
  const [youtubeId, setYoutubeId]                   = useState('')
  const [currentFileName, setcurrentFileName]       = useState('')
  const [duration, setDuration]                     = useState(0)

  // FORM VALIDATION STATES
  const [isNamaInvalid, setIsNamaInvalid]         = useState(false)
  const [isUrutanInvalid, setIsUrutanInvalid]     = useState(false)
  const [isSectionInvalid, setIsSectionInvalid]   = useState(false)
  const [isFileInvalid, setIsFileInvalid]         = useState(false)
  const [isFileTypeInvalid, setIsFileTypeInvalid] = useState(false)
  const [isMaxGroupValid, setIsMaxGroupValid]     = useState(true)
  const [isUploading, setIsUploading]             = useState(false)

  /* =========================================== Refs =========================================== */
  const refInputName     = useRef()
  const refSelectSection = useRef()
  const refInputUrutan   = useRef()
  const refMaxGroup      = useRef()

  /* ========================================= Functions ======================================== */
  function getExistingContentsBySelectedSection() {
    if (!sectionId) {
      setExistingContents([])
    } else {
      sections.forEach((section) => {
        if (section.id === sectionId) {
          setExistingContents(section.contents)
        }
      })
    }
  }

  async function getFeedsList() {
    const response = await getRequest('feed')
    if (response) {
      const options = response.data.map((item) => ({
        value: item.id,
        label: item.description,
      }))
      setFeeds(options)
    } else {
      console.error('ERROR', response)
    }
  }

  function handleChangeName(event) {
    setNamaKonten(event.target.value)
  }

  function handleChangeUrutan(event) {
    setUrutan(Math.abs(event.target.value))
  }

  function handleChangeSection(event) {
    setSectionId(event.target.value)
  }

  function handleChangePrecontent(event) {
    setPrecontentId(event.target.value)
  }

  function handleChangeDate(event) {
    setDisplayAt(event.target.value)
  }

  function handleChangeActive() {
    if (active === 1) {
      setActive(0)
    }
    if (active === 0) {
      setActive(1)
    }
  }

  function handleChangeDesc(event) {
    setDescription(event.target.value)
  }

  function handleChangeEndedAt(event) {
    setEndedAt(event.target.value)
  }

  function handleUseLink() {
    setSelectVideoSource({
      link: true,
      internal: false,
    })
  }

  function handleUseInternalFile() {
    setSelectVideoSource({
      link: false,
      internal: true,
    })
  }

  function handleChangeEnableGroupKey() {
    if (enableGroupKey) {
      setEnableGroupKey(false)
    } else {
      setEnableGroupKey(true)
    }
  }

  function validateFileExtension(fileName) {
    const fileExtension = fileName.split('.').pop()
    const correctExtension = 'mp4'
    if (fileExtension !== correctExtension) {
      setIsFileTypeInvalid(true)
      return 'tidak sesuai'
    } else {
      setIsFileTypeInvalid(false)
      return 'sesuai'
    }
  }

  async function handleFileContent(content) {
    if (typeof content === 'string') {
      setLink(content)

      if (content.includes('drive.google.com')) {
        setContentsUrlLink({ name: null, data: content, source: 'gdrive' })
      } else if (content.includes('youtube.com')) {
        setContentsUrlLink({ name: null, data: content, source: 'youtube' })
      } else {
        setContentsUrlLink({ name: null, data: content, source: 'umum' })
      }
    } else if (`${typeof content}` === 'object') {
      const check = validateFileExtension(content.name)
      if (check === 'sesuai') {
        setcurrentFileName(content.name)
        setFiles(content)
        setContentUrlInternal({
          name: content.name,
          data: 'internal',
          source: 'internal',
        })
        let getDur = await getMediaDuration(content)
        let durSec = Math.round(getDur)
        setDuration(durSec)
      }
    }
  }

  function handleChangeFeedback(val) {
    setFeedId(val)
  }

  function handleFileValidation() {
    if (selectVideoSource.link === true) {
      return contentsUrlLink
    } else if (selectVideoSource.internal === true) {
      return contentUrlInternal
    }
  }

  function handleChangeEnableGroup() {
    if (enableGroup) {
      setEnableGroup(false)
      setMaxGroup('')
      setIsMaxGroupValid(true)
    } else {
      setEnableGroup(true)
      setIsMaxGroupValid(false)
    }
  }

  function handleChangeMaxGroup(event) {
    if (event.target.value) {
      const absolute = Math.abs(event.target.value)
      const integer = Math.round(absolute)
      setMaxGroup(integer)
      if (integer <= 0) {
        setIsMaxGroupValid(false)
      } else {
        setIsMaxGroupValid(true)
      }
    } else {
      setMaxGroup('')
      setIsMaxGroupValid(false)
    }
  }

  function handleChangeDescGroup(event) {
    setDescGroup(event.target.value)
  }

  function handleChangeVidshowNav() {
    if (vidshowNav === 1) {
      setVidshowNav(0)
    }
    if (vidshowNav === 0) {
      setVidshowNav(1)
    }
  }

  function handleChangeApresiasi(event) {
    setApresiasi(event.target.value)
  }

  function handleChangeRating(value) {
    setRating(value ? 1 : 0)
  }

  function toBeScoreValidation() {
    if (toBeScore.isScore) {
      return (toBeScore.isKeterampilan === true || toBeScore.isPengetahuan === true) && toBeScore.selectedTypeScore
    }

    return true
  }

  function handleValidation() {
    const contents_url = handleFileValidation()
    const newUrutan = urutan ? Math.abs(parseInt(urutan)) : 0
    const feedback = isFeedActive === 1 ? feedId : ''

    if (
      namaKonten &&
      urutan &&
      sectionId &&
      contents_url.data &&
      isMaxGroupValid &&
      toBeScoreValidation()
    ) {
      setIsNamaInvalid(false)
      setIsSectionInvalid(false)
      setIsUrutanInvalid(false)
      setIsFileInvalid(false)
      handleSubmitForm(
        contents_url,
        namaKonten,
        sectionId,
        newUrutan,
        active,
        displayAt,
        preContentId,
        feedback.value,
        maxGroup,
        descGroup,
        endedAt,
        description,
        vidshowNav,
        apresiasi,
        rating,
      )
    } else {
      if (!isMaxGroupValid) {
        if (refMaxGroup) {
          refMaxGroup.current.focus()
        }
      }

      if (!sectionId) {
        setIsSectionInvalid(true)
        refSelectSection.current.focus()
      } else {
        setIsSectionInvalid(false)
      }

      if (!urutan) {
        setIsUrutanInvalid(true)
        refInputUrutan.current.focus()
      } else {
        setIsUrutanInvalid(false)
      }

      if (!contents_url || contents_url.data === '') {
        setIsFileInvalid(true)
      } else {
        setIsFileInvalid(false)
      }

      if (!namaKonten) {
        setIsNamaInvalid(true)
        refInputName.current.focus()
      } else {
        setIsNamaInvalid(false)
      }

      window.notification('Mohon', 'lengkapi forms data')

      if (!toBeScoreValidation()) {
        window.notification('Mohon', 'lengkapi juga data "Jadikan Sebagai Penilaian"')
      }
    }
  }

  async function handleSubmitForm(
    contentUrl,
    namaKonten,
    sectionId,
    urutan,
    active,
    displayAt,
    preContentId,
    feedId,
    maxGroup,
    descGroup,
    endedAt,
    description,
    vidshowNav,
    apresiasi,
    rating,
  ) {
    let form = new FormData()
    form.append('duration', duration)
    form.append('content_type', 3)
    form.append('contents_url', JSON.stringify(contentUrl))
    form.append('title', namaKonten)
    form.append('section_id', sectionId)
    form.append('urutan', urutan)
    form.append('active', active)
    form.append('vidshow_nav', vidshowNav)
    form.append('rating', rating)

    form.append('is_score', !!toBeScore.isScore)

    if (toBeScore.isScore) {
      form.append('is_keterampilan', !!toBeScore.isKeterampilan)
      form.append('is_pengetahuan', !!toBeScore.isPengetahuan)
      form.append('type_score_id', toBeScore.selectedTypeScore)
    }

    if (Array.isArray(selectedStudents) && !!selectedStudents.length) {
      selectedStudents.forEach((selectedStudent, selectedStudentIndex) => {
        form.append(`spesifik_user_id[${selectedStudentIndex}]`, selectedStudent.id)
      })
    }

    if (displayAt) {
      form.append('display_at', displayAt)
    }

    if (endedAt) {
      form.append('ended_at', endedAt)
    }

    if (description) {
      form.append('deskripsi', description)
    }

    if (preContentId) {
      form.append('precontent_id', preContentId)
    }

    if (feedId) {
      form.append('feedback', feedId)
    }

    if (enableGroup) {
      form.append('group_status', 1)
      if (maxGroup) {
        form.append('group_max', maxGroup)
      }
      if (descGroup) {
        form.append('group_description', descGroup)
      }
    }

    if (apresiasi) {
      form.append('apresiasi', apresiasi)
    }

    if (contentUrl.source === 'internal') {
      const { id } = JSON.parse(localStorage.getItem('user'))
      const profile_id = JSON.parse(localStorage.getItem('profile')).id
      form.append('path', `upload/${profile_id}/classes/contents`)
      form.append('temp_name', `file-temp-${id}-${Date.now()}.mp4`)
      form.append('file_upload', files)
    }

    setIsUploading(true)
    const response = await postRequest('contents', form)
    setIsUploading(false)
    if (response) {
      if (enableGroupKey) {
        let formkey = new FormData()
        formkey.append('description', prerequisite)
        formkey.append('content_id', response.data.id)

        const response1 = await postRequest('contentTakeAway', formkey)
        if (response1) {
          window.notification('Materi', 'berhasil ditambahkan', 'success')
          history.push(`/kelas/${location.state.kelasId}`)
        }
      } else {
        window.notification('Materi', 'berhasil ditambahkan', 'success')
        history.push(`/kelas/${location.state.kelasId}`)
      }
    } else {
      console.error("ERROR", response);
      window.notification(
        'Terjadi kesalahan',
        'Coba beberapa saat lagi',
        'error',
      )
    }
  }

  /* ========================================== Effects ========================================= */
  useEffect(() => {
    getFeedsList()
  }, [])

  useEffect(() => {
    getExistingContentsBySelectedSection()
  }, [sectionId])

  useEffect(() => {
    setYoutubeId(linkContent.split('=').pop())
  }, [linkContent])

  useEffect(() => {
    setPreviewVideo(contentUrlInternal.data)
  }, [contentUrlInternal])

  /* ========================================== Output ========================================== */
  return (
    <TemplateAdmin>
      <Container>
        <Header
          pageName="Tambah Materi Video"
          linkName="Materi Video"
          links={links}
        />

        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-header">
                <h5>
                  <i className="fas fa-play-circle mr-1" />
                  Informasi Video
                </h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <form>
                      {/* Input Nama Konten */}
                      <FormInputName
                        label="Nama Video"
                        placeholder="Nama Video"
                        namaKonten={namaKonten}
                        isNamaInvalid={isNamaInvalid}
                        handleChangeName={handleChangeName}
                        refInputName={refInputName}
                      />

                      {/* Video Form Group */}
                      <fieldset className="form-group row mb-5">
                        <label className="col-sm-3 col-form-label">
                          <span className="mr-1">Video</span>
                        </label>
                        <div className="col-sm-9 row mb-3">
                          <div className="col">
                            {/* Select Source Youtube*/}
                            <div className="form-check">
                              <input
                                onChange={() => handleUseLink()}
                                className="form-check-input"
                                type="radio"
                                name="selectVideoSource"
                                id="youtubeUrl"
                                defaultValue={1}
                                defaultChecked={true}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="youtubeUrl"
                              >
                                <i className="feather icon-link mr-1" />
                                <span>Link</span>
                                <span className="ml-1">
                                  (Google Drive, Youtube, atau link umum)
                                </span>
                              </label>
                            </div>

                            {/* Input URL */}
                            {selectVideoSource.link ? (
                              <div className="mb-4">
                                <InfoGdrive />
                                <input
                                  type="text"
                                  value={linkContent}
                                  onChange={(event) =>
                                    handleFileContent(event.target.value)
                                  }
                                  className="form-control my-3"
                                  placeholder="Link: https://youtube.com/watch?v=xyz atau https://drive.google.com/file/d/xyz"
                                />
                                {linkContent ? (
                                  <PreviewVideoLink
                                    link={linkContent}
                                    youtubeId={youtubeId}
                                  />
                                ) : null}
                              </div>
                            ) : null}

                            {/* Select Source Internal */}
                            <div className="form-check">
                              <input
                                onChange={() => handleUseInternalFile()}
                                className="form-check-input"
                                type="radio"
                                name="selectVideoSource"
                                id="internalFile"
                                defaultValue={0}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="internalFile"
                              >
                                <i className="fas fa-file-video mr-1" />
                                <span>Upload file</span>
                                <span className="ml-1">(mp4)</span>
                              </label>
                            </div>

                            {/* Input File Video */}
                            {selectVideoSource.internal ? (
                              <div className="custom-file my-3">
                                <input
                                  type="file"
                                  onChange={(event) =>
                                    handleFileContent(event.target.files[0])
                                  }
                                  className="custom-file-input"
                                  id="inputFileVideo"
                                />
                                <label
                                  className="custom-file-label"
                                  htmlFor="inputFileVideo"
                                >
                                  {currentFileName
                                    ? currentFileName
                                    : 'Pilih file video mp4'}
                                </label>
                                {isFileTypeInvalid ? (
                                  <label className="col small form-text text-danger">
                                    Type file video harus mp4.
                                  </label>
                                ) : null}
                              </div>
                            ) : null}
                            {isFileInvalid ? (
                              <InvalidText name={'Video'} />
                            ) : null}
                          </div>
                        </div>
                      </fieldset>

                      {/* Switch vidshow nav */}
                      <FormVideoNav
                        vidshowNav={vidshowNav}
                        handleChangeVidNav={handleChangeVidshowNav}
                      />

                      {/* Input Urutan */}
                      <FormInputUrutan
                        urutan={urutan}
                        handleChangeUrutan={handleChangeUrutan}
                        isUrutanInvalid={isUrutanInvalid}
                        refInputUrutan={refInputUrutan}
                      />

                      {/* Input deskripsi */}
                      <FormInputDesc
                        description={description}
                        handleChangeDesc={handleChangeDesc}
                      />

                      {/* Input Apresiasi */}
                      <FormTextArea
                        id="formInputApresiasi"
                        label="Apresiasi"
                        placeholder="Apresiasi/pesan setelah siswa menyelesaikan materi (opsional)"
                        className="mb-5"
                        value={apresiasi}
                        handleChange={handleChangeApresiasi}
                      />

                      {/* Select Section */}
                      <FormSelectSection
                        sections={sections}
                        handleChangeSection={handleChangeSection}
                        isSectionInvalid={isSectionInvalid}
                        refSelectSection={refSelectSection}
                      />

                      {/* Select Precontent */}
                      <FormSelectPrecontent
                        existingContents={existingContents}
                        handleChangePrecontent={handleChangePrecontent}
                      />

                      {/* Input Tanggal Ditampilkan */}
                      <FormInputTanggal
                        existingDisplayAt={displayAt}
                        handleChangeDate={handleChangeDate}
                      />

                      {/* Input ended at */}
                      <FormInputEndedAt
                        endedAt={endedAt}
                        handleChangeEndedAt={handleChangeEndedAt}
                      />

                      {/* Rating */}
                      <FormSwitch
                        id="formRating"
                        label="Rating Materi"
                        value={rating}
                        handleChange={handleChangeRating}
                      />

                      {/* Select Feedback */}
                      <FormSelectFeedback
                        existingFeedId={feedId}
                        existingFeeds={feeds}
                        isFeedActive={isFeedActive}
                        setIsFeedActive={setIsFeedActive}
                        handleChangeFeeds={handleChangeFeedback}
                        getFeedList={getFeedsList}
                      />

                      {/* Swicth Group Kecil */}
                      <FormGroupKecil
                        enableGroup={enableGroup}
                        handleChangeEnableGroup={handleChangeEnableGroup}
                        maxGroup={maxGroup}
                        descGroup={descGroup}
                        handleChangeMaxGroup={handleChangeMaxGroup}
                        handleChangeDescGroup={handleChangeDescGroup}
                        isMaxGroupValid={isMaxGroupValid}
                        refMaxGroup={refMaxGroup}
                      />

                      {/* Select Specific Students */}
                      <FormSelectStudent 
                        selectedStudents={selectedStudents}
                        setSelectedStudents={setSelectedStudents}
                        subMapelId={params?.kelasId}
                        isWithCheckSavedOrNot={false}
                      />

                      {/* Select To Be Score Or Not */}
                      <FormSetToBeScore
                        value={toBeScore}
                        handleChange={setToBeScore}
                      />

                      {/* Select Status */}
                      <FormActiveStatus
                        existingStatus={active}
                        handleChangeStatus={handleChangeActive}
                      />
                      <FormActiveKey
                        enableGroupKey={enableGroupKey}
                        handleChangeEnableGroupKey={
                          handleChangeEnableGroupKey
                        }
                        prerequisite={prerequisite}
                        setPrerequisite={setPrerequisite}
                      />

                      <div className="form-group">
                        <button
                          onClick={() =>
                            history.push(`/kelas/${location.state.kelasId}`)
                          }
                          type="button"
                          className="btn btn-outline-danger has-ripple mr-2"
                        >
                          Kembali
                        </button>
                        {isUploading ? (
                          <button
                            disabled={true}
                            type="button"
                            className="btn btn-success mr-2"
                          >
                            <span
                              className="spinner-border spinner-border-sm mr-1"
                              role="status"
                            />
                            <span>Simpan</span>
                          </button>
                        ) : (
                          <SubmitButton
                            onClick={() => handleValidation()}
                            text="Simpan"
                          />
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </TemplateAdmin>
  )
}
